import React, { memo } from 'react';
import { Tooltip } from 'antd';
import styles from '../table.module.scss';

import { documentsConstants } from '../../constants/documents.constants';

const TypeCell = memo(({ record, getPopupContainer = () => document.body }) => {
  const type = record.type && record.type.id;
  return (
    type && (
      <Tooltip
        title={record.type.name}
        mouseLeaveDelay={0}
        getPopupContainer={getPopupContainer}
      >
        {documentsConstants.docTypeSVGIcon(type, 20) && (
          <div className={styles.iconCover}>
            {documentsConstants.docTypeSVGIcon(type, 20)}
          </div>
        )}
        {/* <div
          style={{
            fontWeight: 'bold',
            fontSize: '10px',
            textAlign: 'center',
          }}
        >
          {record.type.name}
        </div> */}
      </Tooltip>
    )
  );
});

export default TypeCell;
